import React from 'react';
import { FaHeart } from 'react-icons/fa';

const AdminFooter = () => {
  return (
    <footer className="bg-white py-4 px-6"> {/* Enlevé border-t */}
      <div className="flex flex-col md:flex-row items-center justify-between">
        <div className="text-sm text-gray-600">
          © {new Date().getFullYear()} EFIS Admin. All rights reserved.
        </div>
        <div className="text-sm text-gray-500 mt-2 md:mt-0">
          Developed by <FaHeart className="inline text-red-500 mx-1" /> <a href="">Amine Makni</a>

        </div>
      </div>
    </footer>
  );
};

export default AdminFooter;